const TrackingEventsConstants = {
    OPEN_ADD_PROPERTY_MODAL: 'openAddPropertyModal',
};

export default TrackingEventsConstants;
